import { createStore, storeKey } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// import other stores
import user from './user';
import editor from './editor';
import dashboard from './dashboard';

const api_url = 'https://sheetcreator.co.za';

export default createStore({
    modules: {
        user,
        editor,
        dashboard
    },
    plugins: [
        createPersistedState({
            key: 'instance-data',
            paths: [
                'login',
                'editor'
            ],
            storage: window.localStorage
        })
    ],
})
